import React from "react";
import { Grid } from "@mui/material";
import { usePermissions } from "../pages/login/PermissionContext";
export default function LayoutWithbg({ children }) {
  const { userInfo } = usePermissions();
  const accessToken = sessionStorage.getItem("accessToken");
  return (
    <div
      style={{
        // The artwork used to be painted across THIS element, which is as tall
        // as the whole page — so `cover` cropped it by page height and the same
        // banner looked different on every screen (icon pattern on a short
        // page, blank zoomed-in band on a tall one). It now lives on the header
        // strip below, whose height is its own content, so the crop is
        // identical everywhere. Keeping it off a full-page element also keeps
        // it out of scroll/resize repaints.
        backgroundColor: "#FDFDFD",
        display: "flex",
        flexDirection: "column",
        flex: 1,
      }}
    >
      {/* Header banner — carries the artwork. Fixed height so the crop never
          depends on how long the page underneath happens to be. */}
      <Grid
        container
        alignItems="center"
        sx={{
          padding: "0 20px",
          height: 48,
          flexShrink: 0,
          fontFamily: "Arial, sans-serif",
          backgroundImage: "url('/newImages/login_background.svg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          // The artwork is a 3.9 MB SVG. Rasterising it is expensive, so give
          // the banner its own compositing layer: the browser then keeps the
          // rendered bitmap and re-uses it instead of re-rasterising the SVG
          // whenever something else on the page triggers a repaint.
          transform: "translateZ(0)",
        }}
      >
        {/* Empty space taking 8 columns */}
        <Grid item xs={0} sm={8}></Grid>
        {/* Facility Name - only show if access token is present */}
        {/* {accessToken && (
          <Grid item xs={2}>
            <div
              style={{ fontSize: "14px", fontWeight: "bold", color: "#000" }}
            >
              Facility Name :{" "}
              <span style={{ fontWeight: "normal" }}>
                {userInfo?.facility_name || "-"}
              </span>
            </div>
          </Grid>
        )} */}
        <Grid item xs={0} sm={2}></Grid>
        {/* ORG Code moved to the profile dropdown in the top-right */}
      </Grid>
      {/* Page content — flush under the banner.
          This used to be two nested wrappers: an outer one that vertically
          CENTRED its child, and an inner white card with its own background.
          Together they rendered the page as a panel floating inside another
          panel. One stretched container instead, so whatever a module renders
          owns the surface edge to edge. */}
      <div
        style={{
          flex: 1,
          minWidth: 0,
          display: "flex",
          flexDirection: "column",
        }}
      >
        {children}
      </div>
    </div>
  );
}
